module.exports = __webpack_public_path__ + "static/image/weChat-l.00b8478.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weChat-l.jpg
// module id = 380
// module chunks = 1